import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Customer } from '@app/core/business/customer/customer';
import { Franco } from '@app/core/business/franco/franco';
import { Order } from '@app/core/business/order/order';
import { ContextService } from '@app/core/service/context.service';

@Component({
  selector: 'app-dialog-franco',
  templateUrl: './dialog-franco.component.html',
  styleUrls: ['./dialog-franco.component.scss']
})
export class DialogFrancoComponent implements OnInit {
  public contextOrder: Order;
  public contextFranco: Franco;
  public contextCustomer: Customer;

  constructor(public dialogRef: MatDialogRef<DialogFrancoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogFrancoData, public contextService: ContextService) { }

  ngOnInit(): void {
    this.contextService.fullContext$.subscribe((context) => {
      this.contextFranco = context.franco;
      this.contextOrder = context.order;
      this.contextCustomer = context.customer;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public setCompany(companyCode: string) {
    this.contextFranco = null;
    this.onNoClick();
    this.contextService.setSelectedCompany(companyCode);
  }

  public calculatePercentagePn(): number {
    let order = this.contextFranco?.orders.find(o => new Date(o.date) == new Date() && o.company == 'PRONATURA');
    if (order !== null && order !== undefined)
      return 0;
    if (this.contextOrder && this.contextOrder.price?.seuilFranco && this.contextOrder.price?.seuilFranco > 0 && this.contextOrder.price?.total) {
      const totalPrice = parseFloat(this.contextOrder.price.total.replace(/\s/g, ''));
      const percent = Math.round((totalPrice / this.contextOrder.price.seuilFranco) * 100);
      return percent < 100 ? percent : 100;
    }
    return 0;
  }

  public calculatePercentageVtf(): number {
    let order = this.contextFranco?.orders.find(o => new Date(o.date) == new Date() && o.company == 'VITAFRAIS');
    if (order !== null && order !== undefined)
      return 0;
    if (this.contextOrder && this.contextOrder.price?.seuilFranco && this.contextOrder.price?.seuilFranco > 0 && this.contextOrder.price?.total) {
      const totalPrice = parseFloat(this.contextOrder.price.total.replace(/\s/g, ''));
      const percent = Math.round((totalPrice / this.contextOrder.price.seuilFranco) * 100);
      return percent < 100 ? percent : 100;
    }
    return 0;
  }

  public calculatePercentage(): number {
    if (this.contextService.fullContext?.customer?.isFrancoUnique && this.contextFranco && this.contextFranco?.uniqueFrancoMinimalOrderAmount &&
      this.contextFranco?.uniqueFrancoMinimalOrderAmount > 0) {
        const totalPrice = this.contextFranco.pronaturaTotalAmount + this.contextFranco.vitafraisTotalAmount;
        const percent = Math.round((totalPrice / this.contextFranco.uniqueFrancoMinimalOrderAmount) * 100);
        return percent < 100 ? percent : 100;
    } else if (!this.contextService.fullContext?.customer?.isFrancoUnique && this.contextOrder && this.contextOrder.price?.seuilFranco && this.contextOrder.price?.seuilFranco > 0 &&
      this.contextOrder.price?.total) {
        const totalPrice = parseFloat(this.contextOrder.price.total.replace(/\s/g, ''));
        const percent = Math.round((totalPrice / this.contextOrder.price.seuilFranco) * 100);
        return percent < 100 ? percent : 100;
    }
    return 0;
  }

}

export class DialogFrancoData {
  title: string;
  content: string;
  contextFranco: Franco;
}
